export enum SeasonOfficialsTableColumns {
  Logo = "logo",
  NameFullLocal = "nameFullLocal",
  PersonId = "personId",
  ExternalId = "externalId",
  Role = "role",
  Gender = "gender",
  Nationality = "nationality",
  Status = "status",
  Bib = "bib",
  DateFrom = "dateFrom",
  DateTo = "dateTo",
  EntityGroupNameFullLocal = "entityGroupNameFullLocal",
  EntityNameFullLocal = "entityNameFullLocal",
  RoleNumber = "roleNumber",
  RoleSubType = "roleSubType",
  RoleId = "roleId",
}
